export const OrganizationIndustries = [
  'softwareDevelopment',
  'agency',
  'consultancy',
  'itServices',
  'architectureEngineering',
  'accountFinance',
] as const;

export type IndustryKey = (typeof OrganizationIndustries)[number];
